module.exports = __webpack_public_path__ + "static/img/湖南银行照片反面.83a6874.png";


//////////////////
// WEBPACK FOOTER
// ./static/hunanDIY/湖南银行照片反面.png
// module id = F1WU
// module chunks = 24